import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useEmbedVisibilitySettings = (useLocalStorage: boolean = false) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const visibilitySettings = useMemo(() => {
    const visibilitySettings = {
      showCustomerDetails: queryParams.get('showCustomerDetails') !== 'false',
      showChatAssignee: queryParams.get('showChatAssignee') !== 'false',
      showChatListPanel: queryParams.get('showChatListPanel') !== 'false',
      showChatMarkDone: queryParams.get('showChatMarkDone') !== 'false',
      showChatTagList: queryParams.get('showChatTagList') !== 'false',
      showChatAddTag: queryParams.get('showChatAddTag') !== 'false',
      showChatCart: queryParams.get('showChatCart') !== 'false',
      showOnlyTemplateCreateFlow: queryParams.get('showOnlyTemplateCreateFlow') == 'true',
      showChatMenu: queryParams.get('showChatMenu') !== 'false',
      showAddToBroadcastChannel: queryParams.get('showAddToBroadcastChannel') !== 'false',
      showChatFilters: queryParams.get('showChatFilters') !== 'false',
      showChatSearch: queryParams.get('showChatSearch') !== 'false',
      showChatSelection: queryParams.get('showChatSelection') !== 'false',
      showAddCustomField: queryParams.get('showAddCustomField') !== 'false',
      showNotes: queryParams.get('showNotes') !== 'false',
      showParticipants: queryParams.get('showParticipants') !== 'false',
      showSidebar: queryParams.get('showSidebar') !== 'false',
      showCallHistory: queryParams.get('showCallHistory') !== 'false',
      showBulkMarkAsDone: queryParams.get('showBulkMarkAsDone') !== 'false', // show bulk mark as done button in chat header
      showLogoutInMenuHeader: queryParams.get('showLogoutInMenuHeader') === 'true',
      sendTemplatePopupMinimized: queryParams.get('sendTemplatePopupMinimized') == 'true', // remove create template and filters with limiting font size
    };
    if (queryParams.get('clearLocalStorage') === 'true') {
      localStorage.removeItem('DT_EMBED_VISIBILITY_SETTINGS');
    }
    if (useLocalStorage) {
      const prevSettings = JSON.parse(localStorage.getItem('DT_EMBED_VISIBILITY_SETTINGS') || '{}');
      if (Object.keys(prevSettings).length === 0) {
        localStorage.setItem('DT_EMBED_VISIBILITY_SETTINGS', JSON.stringify(visibilitySettings));
        return { ...visibilitySettings };
      }
      return {
        ...prevSettings,
      };
    }
    return visibilitySettings;
  }, [queryParams, useLocalStorage]);

  return visibilitySettings;
};

export default useEmbedVisibilitySettings;
